/* eslint-disable @typescript-eslint/no-unused-vars */
import { groupsApis } from '@/configs/apis/groups';
import { useChatContext } from '@/contexts/chat/context';
import Dialog from '@/components/dialog';
import type { ChatGroupMemberIdArgs } from '@/contexts/chat/scripts/hooks/useChatGroup/types';
import { GroupEncryptionStatus, GroupStatus } from '@/configs/apis/groups/interface';
import { pushLog } from '@/scripts/utils/devUtils';
import { GroupSettingButton } from '../group-setting-button';
import ExitIcon from '../../images/exit-icon.svg?react';
import DisbandIcon from '../../images/disband-icon.svg?react';
import styles from './index.module.scss';
import type { GroupSettingButtonCardProps } from './interface';

export const GroupSettingButtonCard = ({
  chat,
  user,
  normalMemberList,
  isGroupOwner,
  closeSettings,
}: GroupSettingButtonCardProps) => {
  const {
    chatGroup: {
      // removeGroups,
      updateGroups,
      removeMembers,
      chatGroupState,
    },
  } = useChatContext();

  const clearChatHistory = useRef(false);

  const inGroup = useMemo(() => {
    return normalMemberList?.some((item) => item.user_id === user?.userId);
  }, [normalMemberList, user?.userId]);

  const groupInfo = useMemo(() => {
    return chatGroupState.getGroup(chat.chat_id);
  }, [chat.chat_id, chatGroupState]);

  const ExitContent = ({
    checked,
    onChange,
  }: {
    checked: boolean;
    onChange: (value: boolean) => void;
  }) => {
    const [value, setValue] = useState(checked);
    return (
      <Checkbox
        style={{ display: 'none' }}
        className={styles.checkbox}
        checked={value}
        onChange={(e) => {
          setValue(e.target.checked);
          onChange?.(e.target.checked);
        }}
      >
        <span>Clear chat history</span>
      </Checkbox>
    );
  };

  const handleExitGroup = useCallback(async () => {
    Dialog({
      title: <div>{`Leaving group chat “${chat.name}”`}</div>,
      content: (
        <ExitContent
          checked={clearChatHistory.current}
          onChange={(value) => (clearChatHistory.current = value)}
        />
      ),
      onConfirm: async () => {
        const res = await (groupInfo?.is_encryption === GroupEncryptionStatus.IS
          ? groupsApis.exitEncryptGroup([chat.chat_id])
          : groupsApis.exitGroup([chat.chat_id]));
        if (res.quit_fail_list?.length) {
          // TODO amo
          pushLog('exit-group', [res, res.quit_fail_list, res.quit_fail_list.length]);
          message.error('Failed to leave group');
          return res;
        }
        const params: ChatGroupMemberIdArgs[] = [
          {
            id: chat.chat_id,
            args: [user?.userId ?? ''],
          },
        ];
        await removeMembers(params, false);
        if (clearChatHistory.current) {
          // TODO amo: clear chat history
        }
        closeSettings();
        return res;
      },
    });
  }, [
    chat.name,
    chat.chat_id,
    groupInfo?.is_encryption,
    user?.userId,
    removeMembers,
    closeSettings,
  ]);

  const handleDisbandGroup = useCallback(async () => {
    Dialog({
      title: 'Disband Group',
      content: `Disbanding the group will remove all group members. `,
      onConfirm: async () => {
        const res = await groupsApis.dismissGroup([chat.chat_id]);
        if (res?.disband_fail_list?.length > 0) {
          message.error('Failed to disband group');
          return;
        }
        // const params: ChatGroupMemberIdArgs[] = [
        //   {
        //     id: chat.chat_id,
        //     args: memberList?.map((item) => item.user_id) ?? [],
        //   },
        // ];
        // await removeMembers(params, false);
        // await removeGroups([chat.chat_id])
        await updateGroups([
          {
            group_id: chat.chat_id,
            status: GroupStatus.DISBAND,
          },
        ]);
        closeSettings();
        return res;
      },
    });
  }, [chat.chat_id, closeSettings, updateGroups]);

  const handleAssignGroupOwner = useCallback(async () => {
    // const res = await groupsApis.updateGroupInfo({
    //   gid: chat.chat_id,
    //   creator_uid: '123',
    // });
    // Dialog({
    //   title: 'Coming Soon',
    //   content: 'This feature is not available yet.',
    // });
    message.info('Coming soon.');
    console.log('handleAssignGroupOwner=>', chat.chat_id);
  }, [chat.chat_id]);

  return (
    <div className={styles.groupSettingButtonCard}>
      {!isGroupOwner && inGroup && (
        <GroupSettingButton type="danger" icon={<ExitIcon />} onClick={handleExitGroup}>
          Leave Group
        </GroupSettingButton>
      )}
      {isGroupOwner && (
        <>
          <GroupSettingButton
            type="danger"
            icon={<DisbandIcon />}
            onClick={handleDisbandGroup}
          >
            Disband Group
          </GroupSettingButton>
          {/* <GroupSettingButton
            type="danger"
            icon={<AssignIcon />}
            onClick={handleAssignGroupOwner}
          >
            Assign as Group Owner
          </GroupSettingButton> */}
        </>
      )}
    </div>
  );
};
